import { render, staticRenderFns } from "./QueAndAns.vue?vue&type=template&id=4d6f0236&scoped=true&"
import script from "./QueAndAns.vue?vue&type=script&lang=js&"
export * from "./QueAndAns.vue?vue&type=script&lang=js&"
import style0 from "./QueAndAns.vue?vue&type=style&index=0&id=4d6f0236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f0236",
  null
  
)

export default component.exports